"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IgHeartFilledIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.7 15.213a.998.998 0 01-1.4 0l-.46-.437C2.72 10.858 0 8.273 0 5.11 0 2.524 1.932.5 4.4.5c1.392 0 2.728.679 3.6 1.747C8.872 1.18 10.208.5 11.6.5 14.068.5 16 2.524 16 5.11c0 3.163-2.72 5.748-6.84 9.666l-.46.438z",
    clipRule: "evenodd"
  })))
});
IgHeartFilledIcon.displayName = 'IgHeartFilledIcon';
var _default = exports.default = IgHeartFilledIcon;